import type { Notification } from '@/@types/notification'
import { isEmpty } from 'lodash-es'
import { type Ref } from 'react'
import AutoLoadMoreIndicator, { AutoLoadMoreIndicatorProps } from '../AutoLoadMoreIndicator'
import EmptyPlaceholder from '../EmptyPlaceholder'
import VirtualizedListItem from '../VirtualizedListItem'
import CompositeNotification from './CompositeNotification'
import styles from './NotificationList.module.css'

export interface NotificationListProps extends AutoLoadMoreIndicatorProps {
	/**
	 * Notification 数据数组
	 */
	data: Notification[] | undefined
	ref?: Ref<HTMLDivElement>
}

export default function NotificationList({
	data = [],
	isLoading,
	ref,
	...props
}: NotificationListProps) {
	return (
		<>
			{!isLoading && isEmpty(data) ? (
				<EmptyPlaceholder title="这里空空如也" className={styles.emptyPlaceholder} />
			) : (
				data.map((notification) => (
					<VirtualizedListItem key={notification.id} id={notification.id}>
						<div className={styles.item}>
							<CompositeNotification data={notification} />
						</div>
					</VirtualizedListItem>
				))
			)}
			<AutoLoadMoreIndicator isLoading={isLoading} {...props} />
		</>
	)
}
